exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:992px){.ocultar{display:none}}@media (min-width:992px){.ocultar-lg{display:none}}", ""]);

// exports
